// 手机号校验
export const PHONE_REG = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/

// 必填校验
// 校验时避免提示
export const BASE_REQUIRED = [{ required: true, message: '' }]
export const NAME_REQUIRED = /^\w6$/
